import expiredCertificate from './expired-certificate'

export default {
  namespaced: true,
  modules: {
    expiredCertificate,
  },
}
